var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import AudioImg from "@/components/AudioImageWithOverlay";
import draggable from 'vuedraggable';
var ThePlayerCurrentPlaylist = (function (_super) {
    __extends(ThePlayerCurrentPlaylist, _super);
    function ThePlayerCurrentPlaylist() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menu = false;
        _this.player = _this.$store.state.player;
        _this.playlist = [];
        _this.audios = [];
        _this.draggableOptions = {
            disabled: false,
            handle: '.handle',
            ghostClass: 'ghost',
            setData: function (dataTransfer) {
                dataTransfer.setDragImage(document.createElement('div'), 0, 0);
            },
        };
        return _this;
    }
    ThePlayerCurrentPlaylist.prototype.onPlayerPlaylistChange = function (p) {
        this.playlist = p;
        this.$refs.menu["updateDimensions"]();
    };
    ThePlayerCurrentPlaylist.prototype.onDragStart = function () {
        this.$store.dispatch("setAlteringPlaylist", true);
    };
    ThePlayerCurrentPlaylist.prototype.onDragEnd = function (e) {
        var _this = this;
        if (e.oldIndex === this.player.position) {
            this.$store.dispatch("setPosition", e.newIndex);
        }
        else if (e.newIndex <= this.player.position && e.oldIndex > this.player.position) {
            this.$store.dispatch("setPosition", this.player.position + 1);
        }
        else if (e.newIndex >= this.player.position && e.oldIndex < this.player.position) {
            this.$store.dispatch("setPosition", this.player.position - 1);
        }
        this.$store.dispatch("setPlaylist", this.playlist);
        this.$nextTick(function () {
            _this.$store.dispatch("setAlteringPlaylist", false);
        });
    };
    ThePlayerCurrentPlaylist.prototype.remove = function (index) {
        var _this = this;
        this.$store.dispatch("setAlteringPlaylist", true);
        this.$store.dispatch("playlistPull", index);
        if (index <= this.player.position) {
            this.$store.dispatch("setPosition", this.player.position - 1);
        }
        this.$nextTick(function () {
            _this.$store.dispatch("setAlteringPlaylist", false);
        });
    };
    ThePlayerCurrentPlaylist.prototype.clearPlaylist = function () {
        var _this = this;
        this.$store.dispatch("setAlteringPlaylist", true);
        this.$store.dispatch("setPlaylist", [this.$store.getters.audio]);
        this.$store.dispatch("setPosition", 0);
        this.$nextTick(function () {
            _this.$store.dispatch("setAlteringPlaylist", false);
        });
        setTimeout(function () {
            _this.$refs.menu["updateDimensions"]();
        }, 501);
    };
    __decorate([
        Watch("player.playlist", { deep: true, }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerCurrentPlaylist.prototype, "onPlayerPlaylistChange", null);
    ThePlayerCurrentPlaylist = __decorate([
        Component({
            components: {
                AudioImg: AudioImg,
                draggable: draggable,
            }
        })
    ], ThePlayerCurrentPlaylist);
    return ThePlayerCurrentPlaylist;
}(Vue));
export default ThePlayerCurrentPlaylist;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ThePlayer/ThePlayerCurrentPlaylist.vue
// module id = 270
// module chunks = 0